export const latinCharSet = [
    {
        title: "Latin",
        char: "&iexcl;",
        list: [
            {
                char: "&iexcl;",
                desc: "INVERTED EXCLAMATION MARK"
            },
            {
                char: "&cent;",
                desc: "CENT SIGN"
            },
            {
                char: "&pound;",
                desc: "POUND SIGN"
            },
            {
                char: "&curren;",
                desc: "CURRENCY SIGN"
            },
            {
                char: "&yen;",
                desc: "YEN SIGN"
            },
            {
                char: "&brvbar;",
                desc: "BROKEN BAR"
            },
            {
                char: "&sect;",
                desc: "SECTION SIGN"
            },
            {
                char: "&uml;",
                desc: "DIAERESIS"
            },
            {
                char: "&copy;",
                desc: "COPYRIGHT SIGN"
            },
            {
                char: "&trade;",
                desc: "TRADEMARK SIGN"
            },
            {
                char: "&ordf;",
                desc: "FEMININE ORDINAL INDICATOR"
            },
            {
                char: "&laquo;",
                desc: "LEFT-POINTING DOUBLE ANGLE QUOTATION MARK"
            },
            {
                char: "&not;",
                desc: "NOT SIGN"
            },
            {
                char: "&reg;",
                desc: "REGISTERED SIGN"
            },
            {
                char: "&macr;",
                desc: "MACRON"
            },
            {
                char: "&deg;",
                desc: "DEGREE SIGN"
            },
            {
                char: "&plusmn;",
                desc: "PLUS-MINUS SIGN"
            },
            {
                char: "&sup2;",
                desc: "SUPERSCRIPT TWO"
            },
            {
                char: "&sup3;",
                desc: "SUPERSCRIPT THREE"
            },
            {
                char: "&acute;",
                desc: "ACUTE ACCENT"
            },
            {
                char: "&micro;",
                desc: "MICRO SIGN"
            },
            {
                char: "&para;",
                desc: "PILCROW SIGN"
            },
            {
                char: "&middot;",
                desc: "MIDDLE DOT"
            },
            {
                char: "&cedil;",
                desc: "CEDILLA"
            },
            {
                char: "&sup1;",
                desc: "SUPERSCRIPT ONE"
            },
            {
                char: "&ordm;",
                desc: "MASCULINE ORDINAL INDICATOR"
            },
            {
                char: "&raquo;",
                desc: "RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK"
            },
            {
                char: "&frac14;",
                desc: "VULGAR FRACTION ONE QUARTER"
            },
            {
                char: "&frac12;",
                desc: "VULGAR FRACTION ONE HALF"
            },
            {
                char: "&frac34;",
                desc: "VULGAR FRACTION THREE QUARTERS"
            },
            {
                char: "&iquest;",
                desc: "INVERTED QUESTION MARK"
            },
            {
                char: "&Agrave;",
                desc: "LATIN CAPITAL LETTER A WITH GRAVE"
            },
            {
                char: "&Aacute;",
                desc: "LATIN CAPITAL LETTER A WITH ACUTE"
            },
            {
                char: "&Acirc;",
                desc: "LATIN CAPITAL LETTER A WITH CIRCUMFLEX"
            },
            {
                char: "&Atilde;",
                desc: "LATIN CAPITAL LETTER A WITH TILDE"
            },
            {
                char: "&Auml;",
                desc: "LATIN CAPITAL LETTER A WITH DIAERESIS "
            },
            {
                char: "&Aring;",
                desc: "LATIN CAPITAL LETTER A WITH RING ABOVE"
            },
            {
                char: "&AElig;",
                desc: "LATIN CAPITAL LETTER AE"
            },
            {
                char: "&Ccedil;",
                desc: "LATIN CAPITAL LETTER C WITH CEDILLA"
            },
            {
                char: "&Egrave;",
                desc: "LATIN CAPITAL LETTER E WITH GRAVE"
            },
            {
                char: "&Eacute;",
                desc: "LATIN CAPITAL LETTER E WITH ACUTE"
            },
            {
                char: "&Ecirc;",
                desc: "LATIN CAPITAL LETTER E WITH CIRCUMFLEX"
            },
            {
                char: "&Euml;",
                desc: "LATIN CAPITAL LETTER E WITH DIAERESIS"
            },
            {
                char: "&Igrave;",
                desc: "LATIN CAPITAL LETTER I WITH GRAVE"
            },
            {
                char: "&Iacute;",
                desc: "LATIN CAPITAL LETTER I WITH ACUTE"
            },
            {
                char: "&Icirc;",
                desc: "LATIN CAPITAL LETTER I WITH CIRCUMFLEX"
            },
            {
                char: "&Iuml;",
                desc: "LATIN CAPITAL LETTER I WITH DIAERESIS"
            },
            {
                char: "&ETH;",
                desc: "LATIN CAPITAL LETTER ETH"
            },
            {
                char: "&Ntilde;",
                desc: "LATIN CAPITAL LETTER N WITH TILDE"
            },
            {
                char: "&Ograve;",
                desc: "LATIN CAPITAL LETTER O WITH GRAVE"
            },
            {
                char: "&Oacute;",
                desc: "LATIN CAPITAL LETTER O WITH ACUTE"
            },
            {
                char: "&Ocirc;",
                desc: "LATIN CAPITAL LETTER O WITH CIRCUMFLEX"
            },
            {
                char: "&Otilde;",
                desc: "LATIN CAPITAL LETTER O WITH TILDE"
            },
            {
                char: "&Ouml;",
                desc: "LATIN CAPITAL LETTER O WITH DIAERESIS"
            },
            {
                char: "&times;",
                desc: "MULTIPLICATION SIGN"
            },
            {
                char: "&Oslash;",
                desc: "LATIN CAPITAL LETTER O WITH STROKE"
            },
            {
                char: "&Ugrave;",
                desc: "LATIN CAPITAL LETTER U WITH GRAVE"
            },
            {
                char: "&Uacute;",
                desc: "LATIN CAPITAL LETTER U WITH ACUTE"
            },
            {
                char: "&Ucirc;",
                desc: "LATIN CAPITAL LETTER U WITH CIRCUMFLEX"
            },
            {
                char: "&Uuml;",
                desc: "LATIN CAPITAL LETTER U WITH DIAERESIS"
            },
            {
                char: "&Yacute;",
                desc: "LATIN CAPITAL LETTER Y WITH ACUTE"
            },
            {
                char: "&THORN;",
                desc: "LATIN CAPITAL LETTER THORN"
            },
            {
                char: "&szlig;",
                desc: "LATIN SMALL LETTER SHARP S"
            },
            {
                char: "&agrave;",
                desc: "LATIN SMALL LETTER A WITH GRAVE"
            },
            {
                char: "&aacute;",
                desc: "LATIN SMALL LETTER A WITH ACUTE "
            },
            {
                char: "&acirc;",
                desc: "LATIN SMALL LETTER A WITH CIRCUMFLEX"
            },
            {
                char: "&atilde;",
                desc: "LATIN SMALL LETTER A WITH TILDE"
            },
            {
                char: "&auml;",
                desc: "LATIN SMALL LETTER A WITH DIAERESIS"
            },
            {
                char: "&aring;",
                desc: "LATIN SMALL LETTER A WITH RING ABOVE"
            },
            {
                char: "&aelig;",
                desc: "LATIN SMALL LETTER AE"
            },
            {
                char: "&ccedil;",
                desc: "LATIN SMALL LETTER C WITH CEDILLA"
            },
            {
                char: "&egrave;",
                desc: "LATIN SMALL LETTER E WITH GRAVE"
            },
            {
                char: "&eacute;",
                desc: "LATIN SMALL LETTER E WITH ACUTE"
            },
            {
                char: "&ecirc;",
                desc: "LATIN SMALL LETTER E WITH CIRCUMFLEX"
            },
            {
                char: "&euml;",
                desc: "LATIN SMALL LETTER E WITH DIAERESIS"
            },
            {
                char: "&igrave;",
                desc: "LATIN SMALL LETTER I WITH GRAVE"
            },
            {
                char: "&iacute;",
                desc: "LATIN SMALL LETTER I WITH ACUTE"
            },
            {
                char: "&icirc;",
                desc: "LATIN SMALL LETTER I WITH CIRCUMFLEX"
            },
            {
                char: "&iuml;",
                desc: "LATIN SMALL LETTER I WITH DIAERESIS"
            },
            {
                char: "&eth;",
                desc: "LATIN SMALL LETTER ETH"
            },
            {
                char: "&ntilde;",
                desc: "LATIN SMALL LETTER N WITH TILDE"
            },
            {
                char: "&ograve;",
                desc: "LATIN SMALL LETTER O WITH GRAVE"
            },
            {
                char: "&oacute;",
                desc: "LATIN SMALL LETTER O WITH ACUTE"
            },
            {
                char: "&ocirc;",
                desc: "LATIN SMALL LETTER O WITH CIRCUMFLEX"
            },
            {
                char: "&otilde;",
                desc: "LATIN SMALL LETTER O WITH TILDE"
            },
            {
                char: "&ouml;",
                desc: "LATIN SMALL LETTER O WITH DIAERESIS"
            },
            {
                char: "&divide;",
                desc: "DIVISION SIGN"
            },
            {
                char: "&oslash;",
                desc: "LATIN SMALL LETTER O WITH STROKE"
            },
            {
                char: "&ugrave;",
                desc: "LATIN SMALL LETTER U WITH GRAVE"
            },
            {
                char: "&uacute;",
                desc: "LATIN SMALL LETTER U WITH ACUTE"
            },
            {
                char: "&ucirc;",
                desc: "LATIN SMALL LETTER U WITH CIRCUMFLEX"
            },
            {
                char: "&uuml;",
                desc: "LATIN SMALL LETTER U WITH DIAERESIS"
            },
            {
                char: "&yacute;",
                desc: "LATIN SMALL LETTER Y WITH ACUTE"
            },
            {
                char: "&thorn;",
                desc: "LATIN SMALL LETTER THORN"
            },
            {
                char: "&yuml;",
                desc: "LATIN SMALL LETTER Y WITH DIAERESIS"
            }
        ]
    }
];
